import { defineMessages } from "react-intl";
const messages = defineMessages({
    addUserTitle: {
        id: "app.admin.addUser.title.text",
        defaultMessage: "Add New User",
    },
});
export default messages;
